import { render, staticRenderFns } from "./CategorySchool.vue?vue&type=template&id=28c2bbb6&"
import script from "./CategorySchool.vue?vue&type=script&lang=js&"
export * from "./CategorySchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports